/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Logger } from 'twilio-video';
import { participantAPI } from '../api/participant';

let doneSetupTwilioLogger = false;

const twilioLogger = Logger.getLogger('twilio-video');
const originalFactory = twilioLogger.methodFactory;

const twilioLoggerMethodFactory: typeof twilioLogger.methodFactory = (methodName, logLevel, loggerName) => {
  const method = originalFactory(methodName, logLevel, loggerName);
  return function (datetime, level, component, message, data) {
    const prefix = '[Twilio]';
    method(prefix, datetime, level, component, message, data);

    let logData = data;
    if (data) {
      if (typeof data === 'object' && data?.message) {
        // data can be DOMException which does not have code, name, message as enumerable properties
        message += ` ${data}`;
        logData = { code: data?.code, name: data?.name, message: data?.message, ...data };
      } else if (typeof data === 'string') {
        message += ' ' + data;
        logData = { message: data };
      }
    }

    const logRequest = {
      preflight: false,
      browserTime: datetime,
      level,
      message: `${component} ${message}`,
      data: logData,
    };
    participantAPI.rooms.sendBrowserLog(logRequest);
  };
};

// https://www.twilio.com/blog/capturing-twilio-video-js-sdk-logs
export const setupTwilioLogger = () => {
  if (!doneSetupTwilioLogger) {
    twilioLogger.methodFactory = twilioLoggerMethodFactory;
    twilioLogger.setLevel('info');
    doneSetupTwilioLogger = true;
  }
};
